import React, { Component } from 'react';
import { Container, ContainerLarge, Article, Heading, FirstSection, Section, MainColumn, Figure, OneHalf, KeySection, SideColumnBookLeft, SideColumnBookRight } from '../../theme/grid';
import { OverlaySummery } from '../../theme/overlay';
import { HeadingH1, HeadingH2, DropCap, BulletedList } from '../../theme/typography';
import Header from '../../components/Header/Header';
import CallToolsRedesign from '../../assets/CallTools/Redesign/Redesign';
import CallToolsMobile from '../../assets/CallTools/Mobile/Mobile';
import PageFooter from '../../components/PageFooter/PageFooter';
import Footer from '../../components/Footer/Footer';

export default class ImportDataPlugin extends Component {
  static propTypes = {};

  constructor(props) {
      super(props)

      this.handler = this.handler.bind(this);

      if (this.props.location.hash == "#present") {
        this.state = {
            messageShown: false
        };
      } else {
        this.state = {
            messageShown: true
        };
      }

  }



  handler() {
      this.setState({
          messageShown: !this.state.messageShown
      });
  }

  render() {
    return (
      <div>
          <Header theme={"amazon " + this.state.messageShown} color="#0077FF" date="Summer 2020" role="Design, Development" action={this.handler}></Header>
          <Article className={"amazon " + this.state.messageShown}>
            <Container className={this.state.messageShown}>
              <Heading className={this.state.messageShown}>
                <HeadingH2 className="amazon">Amazon</HeadingH2>
                <HeadingH1>Data Plugin</HeadingH1>
                <OverlaySummery className={this.state.messageShown}>
                  <p>I designed the plugin to make it as easy as possible to start working with Mozilla's brand assets.</p>
                  <ul>
                    <li>Imports Layer Styles</li>
                    <li>Interchangable Layer Styles</li>
                    <li>Updates Layer Fills</li>
                  </ul>
                </OverlaySummery>
              </Heading>
              <FirstSection className={this.state.messageShown}>
                <MainColumn>
                  <p><DropCap>S</DropCap>ketch's data tool allows you to override the image or text data in your design with a randomized selection from a provided data set. This is a useful feature but the randomization was making it difficult to create accurate mock-ups. In order to create realistic looking mock-up designers would spend a significant portion of their time copying and pasting in data from our site.</p>
                  <p>In order to speed up this process I created a Sketch Plugin which can access the Goodreads API and import specific book and author data from that plugin for use within our designs. The plugin will override individual layers and can overried multiple layers, symbol instances, groups, and artboards. If the layers are named after specific data items (author name, publishing date, number of reviews, etc) the plugin will automatically replace the data for that particular item. The introduction of this plugin has significantly improved our team's speed and efficiency.</p>
                </MainColumn>
              </FirstSection>
              <KeySection className={this.state.messageShown}>
                <MainColumn>
                  <img alt="" src={require('../../assets/Home/amazon-import.gif')} />
                </MainColumn>
              </KeySection>
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>Features</h2>
                  <p>With the plugin and our corresponding Sketch library a designer should be able to quickly put together a page that's ready for testing and sharing with stakeholders. If a page is created with symbols from our Sketch library and all of the Sketch layers are named after different data items available in the plugin, a designer can selected the artboard and override all of the data on that page with a single click.</p>
                  <BulletedList>
                    <li>
                        <b>Search for any book listed on Goodreads</b>
                        <p>Use the search bar at the top of the plugin to find author and book data.</p>
                    </li>
                    <li>
                        <b>Import book and author data</b>
                        <p>Import information such as title, author, publishing date, reviews, ratings, etc.</p>
                    </li>
                    <li>
                        <b>Uses Goodreads API</b>
                        <p>The plugin hooks into Goodreads API to pull down the most up to date author and book data.</p>
                    </li>
                    <li>
                        <b>Override symbol instanceses, groups, text, and shape layers</b>
                        <p>Select a layer to override its contents. If the layer is unnamed you can select from a number of data items (i.e. number of reviews, publishing date, etc.) </p>
                    </li>
                    <li>
                        <b>Override multiple layers at once</b>
                        <p>You can override multiple layers at once by naaming each of those layers after a specfic data item (i.e. title, author, cover, etc.)</p>
                    </li>
                    </BulletedList>
                </MainColumn>
                <SideColumnBookLeft>
                  <img alt="" src={require('../../assets/Amazon/book-red1.png')} />
                </SideColumnBookLeft>
              </Section>

            </Container>
          </Article>
          <PageFooter theme="amazon" present={this.state.messageShown} leftTitle="none" left="none" leftLink="none" rightTitle="Amazon" right="Review Plugin" rightLink="amazon-review-plugin"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/containers/AmazonImportDataPlugin/ImportDataPlugin.js